/* Remove empty product tabs */
document.addEventListener('DOMContentLoaded', function () {
  function isEffectivelyEmpty(el) {
    const hasMedia = el.querySelector('img, video, iframe, svg, source, embed, object, picture') !== null;
    if (hasMedia) return false;
    const text = (el.textContent || '')
      .replace(/\u200B/g, '')
      .trim();
    return text.length === 0;
  }

  document.querySelectorAll('.product-information accordion-custom').forEach(function (accordion) {
    const details = accordion.querySelector('.details-content');
    if (details && isEffectivelyEmpty(details)) {
      accordion.remove();
    }
  });
});

/* Treatments carousel */
document.addEventListener('DOMContentLoaded', function () {
  var treatmentsEl = document.querySelector('.treatments');
  if (!treatmentsEl) return;

  treatmentsEl.classList.add('swiper');

  var wrapperEl = treatmentsEl.querySelector('.layout-panel-flex');
  if (!wrapperEl) return;

  wrapperEl.classList.add('swiper-wrapper');

  var slides = wrapperEl.querySelectorAll(':scope > .group-block');
  slides.forEach(function (slide) {
    slide.classList.add('swiper-slide');
  });

  var headingBlock = document.querySelector(
    '.treatments-wrapper .section-content-wrapper > .text-block'
  );

  var prevSelector = '.treatments-swiper-prev';
  var nextSelector = '.treatments-swiper-next';

  if (headingBlock) {
    var navContainer = document.createElement('div');
    navContainer.className = 'treatments-swiper-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'swiper-button-prev treatments-swiper-prev';
    prevBtn.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0980/8003/1057/files/prev.png?v=1764757771" alt="Previous">';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'swiper-button-next treatments-swiper-next';
    nextBtn.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0980/8003/1057/files/next.png?v=1764757770" alt="Next">';

    navContainer.appendChild(prevBtn);
    navContainer.appendChild(nextBtn);
    headingBlock.appendChild(navContainer);
  }

  var treatmentsSwiper = new Swiper(treatmentsEl, {
    slidesPerView: 3,
    spaceBetween: 12,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: nextSelector,
      prevEl: prevSelector
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 4
      }
    }
  });
});

/* Products carousel */
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.ui-test-product-list .resource-list');
  if (!container) return;

  container.classList.add('swiper');

  var items = Array.from(container.querySelectorAll('.resource-list__item'));

  var wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  items.forEach(function (item) {
    item.classList.add('swiper-slide');
    wrapper.appendChild(item);
  });

  container.appendChild(wrapper);

  var header = document.querySelector('.ui-test-product-list .section-resource-list__header');

  var prevSelector = '.resource-swiper-prev';
  var nextSelector = '.resource-swiper-next';

  if (header) {
    var navContainer = document.createElement('div');
    navContainer.className = 'resource-swiper-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'swiper-button-prev resource-swiper-prev';
    prevBtn.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0980/8003/1057/files/prev.png?v=1764757771" alt="Prev">';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'swiper-button-next resource-swiper-next';
    nextBtn.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0980/8003/1057/files/next.png?v=1764757770" alt="Next">';

    navContainer.appendChild(prevBtn);
    navContainer.appendChild(nextBtn);
    header.appendChild(navContainer);
  }

  var resourceSwiper = new Swiper(container, {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: nextSelector,
      prevEl: prevSelector
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 6
      }
    }
  });
});

/* Animations */
(() => {
  let io;

  function getObserver() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      }
    }, { root: null, rootMargin: '0px 0px -5% 0px', threshold: 0.1 });
    return io;
  }

  const SELECTORS = [
    'main .h1', 'main .h2', 'main .h3', 'main .h4', 'main .h5', 'main .h6',
    'main h1', 'main h2', 'main h3', 'main h4', 'main h5', 'main h6',
    'main .rte-formatter p', 'main rte-formatter p', 'main rte-formatter ul', 'main rte-formatter ol',
    'main a.button', 'main a.button-secondary', 'main a.link',
    'main accordion-custom details',
    '.product-information product-price',
    '.product-information .buy-buttons-block',
    '.large-logo img',
    'main .text-block.h1', 'main .text-block.h2', 'main .text-block.h3',
    'main .text-block.h4', 'main .text-block.h5', 'main .text-block.h6',
    '.resource-list',
    '.product-grid',
    '.search-page-input__parent',
    '.icon-block__media',
    '.variant-picker',
    'main .image-block',
    '.media-block__media',
    '.email-signup__input-group',
    '.blog-post-featured-image__image',
    '.blog-post-item',
    '.treatments > .layout-panel-flex > .group-block',
    '.results > .layout-panel-flex > *',
    '.skin-concerns > .layout-panel-flex > .group-block',
    '.service-list .service-card'
  ];

  function observeCurrentTargets() {
    const obs = getObserver();
    if (!obs) return;
    const selector = SELECTORS.join(',');
    document.querySelectorAll(selector).forEach(el => {
      if (!el.classList.contains('in-view')) obs.observe(el);
    });
  }

  function init() {
    observeCurrentTargets();
    const main = document.querySelector('main');
    if (main) {
      const mo = new MutationObserver((muts) => {
        for (const mut of muts) {
          if (mut.addedNodes && mut.addedNodes.length) {
            observeCurrentTargets();
            break;
          }
        }
      });
      mo.observe(main, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('page:load', init);
  document.addEventListener('load', init);
  setTimeout(init, 350);
})();